import {WorkrequestDetailsBase} from '../../shared/data-objects/workrequest-details-base';

export class WorkrequestHydDetails extends WorkrequestDetailsBase {
  applicationFeerequired: boolean;
  hydVehicleBackflowDetailsList: HydVehicleBackflowDetails[];

  constructor() {
    super();
    this.applicationFeerequired = true;

    this.hydVehicleBackflowDetailsList = [];
    const row1: HydVehicleBackflowDetails = new HydVehicleBackflowDetails();

    row1.capacity = '';
    row1.civalWorksDomesticDrinkingWater = '';
    row1.isTankRemovable = '';
    row1.registerationNumber = '';
    row1.rpzAirGap = '';

    this.hydVehicleBackflowDetailsList = [row1];
  }

  toUpperCase() {
  }

  setDescriptionOfWork() {
    this.descriptionOfWork = '';
    for (let i = 0; i < this.hydVehicleBackflowDetailsList.length; i++) {
      const hydVehicleBackflowDetails: HydVehicleBackflowDetails = this.hydVehicleBackflowDetailsList[i];
      if (hydVehicleBackflowDetails.registerationNumber === '' && hydVehicleBackflowDetails.capacity === ''
        && (hydVehicleBackflowDetails.isTankRemovable === 'Please select...' || hydVehicleBackflowDetails.isTankRemovable === '')
        && (hydVehicleBackflowDetails.rpzAirGap === 'Please select...' || hydVehicleBackflowDetails.rpzAirGap === '')
        && (hydVehicleBackflowDetails.civalWorksDomesticDrinkingWater === 'Please select...'
          || hydVehicleBackflowDetails.civalWorksDomesticDrinkingWater === ''
        )) {
        continue;
      }

      this.descriptionOfWork += 'REG NO.: ' + hydVehicleBackflowDetails.registerationNumber + ', ';
      this.descriptionOfWork += ' CAPACITY (LITRES): ' + hydVehicleBackflowDetails.capacity + ', ';
      this.descriptionOfWork += ' IS TANK REMOVABLE?: ' + hydVehicleBackflowDetails.isTankRemovable + ', ';
      this.descriptionOfWork += ' RPZ/AIR GAP: ' + hydVehicleBackflowDetails.rpzAirGap + ', ';
      this.descriptionOfWork += ' CIVIL WORKS/DOMESTIC DRINKING WATER: ' +
        hydVehicleBackflowDetails.civalWorksDomesticDrinkingWater;
      this.descriptionOfWork += '\r\n';
    }
  }
}

export class HydVehicleBackflowDetails {
  registerationNumber: string;
  capacity: string;
  isTankRemovable: string;
  rpzAirGap: string;
  civalWorksDomesticDrinkingWater: string;
}



// WEBPACK FOOTER //
// ./src/app/create-application/hyd-form/workrequest-hyd-details.ts